import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { guid } from "@app/Guid"
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineConnectorPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineConnectorPage',
  setup(__props) {

    document.title = "Configure connector"

    const tid = useOrganizationUnitId()
    const id = useId()

    const {
        useCurrentUserQuery,
        useConnectorsOfOrganizationQuery,
        usePipelineDetailsQuery,
        useAttachConnectorCommand
    } = useAdminConfigurePipelineConnectorPage()

    const connectorProviderElement = ref<HTMLIFrameElement>(null)

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const direction = computed(() => modelPipelineDetailsQueryV1.value?.Direction)
    const name = computed(() => `Connector for pipeline ${modelPipelineDetailsQueryV1.value?.Name}`)
    const configPageUrl = computed(() => `${provider.value?.ConfigPageUrl}${tid}`)
    const connectorProviderType = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorProviderType)
    const connectorConfig = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorConfig)
    const connectorId = computed(() => modelPipelineDetailsQueryV1.value?.ConnectorId)

    const { runConnectorsOfOrganizationQueryV1, modelConnectorsOfOrganizationQueryV1 } = useConnectorsOfOrganizationQuery(tid)
    const connectors = computed(() => modelConnectorsOfOrganizationQueryV1.value?.Connectors || [])

    const { invokeAttachConnectorCommandV1, succeedAttachConnectorCommandV1 } = useAttachConnectorCommand(id, tid, userId)

    watch(connectorProviderType, (val) => {
        providerType.value = connectorProviderType.value
    })

    watch(succeedAttachConnectorCommandV1, () => {
        if (succeedAttachConnectorCommandV1.value) location.href = `/#/admin/integrations/pipelines/details/${tid}/${id}`
    })

    onMounted(() => {
        runCurrentUserQueryV1()
        runConnectorsOfOrganizationQueryV1()
        runPipelineDetailsQueryV1()
        window.addEventListener('message', onMessage);
    })

    onUnmounted(() => {
        window.removeEventListener('message', onMessage);
    })

    function onMessage(event) {
        if ((event.source as any)?.frameElement?.name == 'connectorProviderElement') {
            if (event.data?.type == 'Integrations.Connectors.ReadConfig') {
                // set current config once connector iframs is ready
                connectorProviderElement.value?.contentWindow?.postMessage({
                    'type': 'Integrations.Connectors.InitConfig',
                    'data': connectorConfig.value
                })
            }
            else if (event.data?.type == 'Integrations.Connectors.ApplyConnectorConfig') {
                config.value = JSON.stringify(event.data.data);
                invokeCreateConnectorCommandV1({ Id: connectorId.value })
            }
        }
    }

    function handleAttachConnectorCommandV1(connectorId: string) {
        invokeAttachConnectorCommandV1({ ConnectorId: connectorId })
    }

    function handleRefresh() {
        runConnectorsOfOrganizationQueryV1({ Rebuild: true })
    }

return { __sfc: true,tid, id, useCurrentUserQuery, useConnectorsOfOrganizationQuery, usePipelineDetailsQuery, useAttachConnectorCommand, connectorProviderElement, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1, direction, name, configPageUrl, connectorProviderType, connectorConfig, connectorId, runConnectorsOfOrganizationQueryV1, modelConnectorsOfOrganizationQueryV1, connectors, invokeAttachConnectorCommandV1, succeedAttachConnectorCommandV1, onMessage, handleAttachConnectorCommandV1, handleRefresh }
}

})